import { Link } from 'react-router-dom';

const Footer = () => {
  const year = new Date().getFullYear();

  return (
    <footer className="mt-auto border-t border-slate-200 bg-slate-50">
      <div className="container-custom py-12">
        <div className="grid gap-10 md:grid-cols-3">

          {/* Brand */}
          <div>
            <Link to="/" aria-label="Drivor home" className="inline-flex">
              <img src="/brand/logo-primary.svg" alt="Drivor" className="h-[70px] w-auto" />
            </Link>
            <p className="mt-3 max-w-xs text-sm leading-relaxed text-slate-600">
              Professional driver and cab bookings for city, airport, office,
              outstation, event, and corporate travel.
            </p>
          </div>

          {/* Product */}
          <div>
            <p className="text-sm font-semibold text-slate-900">Product</p>
            <ul className="mt-3 space-y-2 text-sm">
              <li><Link to="/how-it-works" className="text-slate-600 hover:text-primary-700">How it works</Link></li>
              <li><Link to="/demo" className="text-slate-600 hover:text-primary-700">Demo</Link></li>
              <li><Link to="/contact" className="text-slate-600 hover:text-primary-700">Contact</Link></li>
            </ul>
          </div>

          {/* Account */}
          <div>
            <p className="text-sm font-semibold text-slate-900">Account</p>
            <ul className="mt-3 space-y-2 text-sm">
              <li>
                <a
                  href="https://app.drivor.in/login"
                  rel="noopener noreferrer"
                  className="text-slate-600 hover:text-primary-700"
                >
                  Login
                </a>
              </li>
              <li>
                <a
                  href="https://app.drivor.in/signup"
                  rel="noopener noreferrer"
                  className="text-slate-600 hover:text-primary-700"
                >
                  Start booking
                </a>
              </li>
              <li>
                <a
                  href="mailto:sales@drivor.in"
                  className="text-slate-600 hover:text-primary-700"
                >
                  sales@drivor.in
                </a>
              </li>
            </ul>
          </div>

        </div>

        <div className="mt-10 border-t border-slate-200 pt-8 text-sm text-slate-500">
          <p>© {year} Drivor. All rights reserved.</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
